import script from "./createApiMerchant.vue?vue&type=script&setup=true&lang=js"
export * from "./createApiMerchant.vue?vue&type=script&setup=true&lang=js"

import "./createApiMerchant.vue?vue&type=style&index=0&id=0f62195d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\TECHNOVA_FD01\\Desktop\\Augustine\\Projects\\XP\\payout-fe\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f62195d"]])

export default __exports__